import FooterForm from "components/features/CmsComponents/Footer";
import TopMenuForm from "components/features/CmsComponents/TopMenu";
import NavigationForm from "components/features/CmsComponents/Navigation";

export const settings = {
  useFormDataDataProvider: true,
  basename: process.env.REACT_APP_BASENAME,
  authorizationApi: process.env.REACT_APP_AUTHORIZATION_API,
  gatewayApi: process.env.REACT_APP_GATEWAY_API,
  files_url: process.env.REACT_APP_FILES_URL,
  cmsAdminApi: process.env.REACT_APP_CMS_ADMIN_API,
  cmsApi: process.env.REACT_APP_CMS_API,
  editApp: process.env.REACT_APP_EDIT_APP,
  usesSeparatePermissions: true,
  usesCustomPermissionValidator: true,
  permissions: "permissions",
  permissionsValidator: (permissions, permission) => {
    return (
      permissions?.role_claims.includes(permission) || permissions?.user_claims?.map(x => x.value).includes(permission)
    );
  },
  // menuStyles: () => {
  //   const { menuStyled } = require("customStyles/menuStyle");
  //   return menuStyled;
  // },
  // datagridStyle: () => {
  //   const { datagridStyle } = require("customStyles/datagridStyle");
  //   return datagridStyle;
  // },
  nestedDatagridStyle: () => {
    const { nestedDatagridStyle } = require("customStyles/datagridStyle");
    return nestedDatagridStyle;
  },
  getUrlTreeComponent: name => {
    switch (name) {
      case "topmenu":
        return TopMenuForm;
      case "navigation":
        return NavigationForm;
      case "footer":
        return FooterForm;
      default:
        throw Error("getUrlTreeComponent - invalid type");
    }
  },
};
